import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

export default function Redirect_team() {
   const navigate = useNavigate();
  
    useEffect(() => {
      navigate('/companymember_list'); 
    }, [navigate]); 
  
    return null; 
}
